import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Image } from '@chakra-ui/react';
import { IoIosArrowDropleft, IoIosArrowDropright } from 'react-icons/io';
import NoImage from 'assets/img/no_image_available.jpg';

const ControlledCarousel = ({ images = [] }) => {
    const [index, setIndex] = React.useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };
    return (
        <Carousel
            indicators={false}
            prevIcon={<IoIosArrowDropleft size={30} fill="#003f68"/>}
            nextIcon={<IoIosArrowDropright size={30} fill="#003f68"/>}
            variant="dark"
            activeIndex={index}
            onSelect={handleSelect}
        >
            { images.length > 0
                ? images.map((image, imageIndex) => (
                    <Carousel.Item key={imageIndex} height="250px">
                        <Image objectFit='cover' height="200px" width="100%" src={image} />
                    </Carousel.Item>
                ))
                : (
                    <Carousel.Item height="250px">
                        <Image objectFit='cover' height="200px" width="100%" src={NoImage} />
                    </Carousel.Item>
                )}
        </Carousel>
    );
};

export default ControlledCarousel;
